import cx from "classnames";

import Button from "components/botanic/Button";

export type Props = {
  googleMapsUrl: string;
  className?: string;
  onClick?: () => void;
};

const DispensaryDirectionsButton = ({
  googleMapsUrl,
  className,
  onClick,
}: Props) => {
  return (
    <>
      <Button
        className={cx("mx-auto mt-sm", className)}
        href={googleMapsUrl}
        iconFilePath="location_marker.svg"
        onClick={onClick}
        prefetch={false}
        rel="noopener noreferrer"
        target="_blank"
        variant="secondary"
      >
        get directions
      </Button>
    </>
  );
};

export default DispensaryDirectionsButton;
